import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import './loader.css';

export function Loader() {
	return <AiOutlineLoading3Quarters icon="icon-park-outline:loading-one" className="loader-icon " />
}

// In-row variant (20px, no text): sits in place of the file icon of a FileRow.
export function RowSpinner({ className = "" }) {
	return (
		<span
			data-testid="row-spinner"
			aria-hidden="true"
			className={`inline-block w-5 h-5 shrink-0 rounded-full border-2 border-cyan-450 border-t-transparent animate-spin ${className}`}
		/>
	);
}
